import React, { useContext, useEffect, useState } from "react";
import Nav from "../component/Nav";
import AllProduct from "../component/AllProduct";
import Tittle from "../component/Tittle";
import Footer from "../component/Footer";
import { useParams } from "react-router-dom";
import UserContext from "../context/UserContext";
import Filter from "../component/Filter";
import GetMoreBooks from "../component/GetMoreBooks";

function Product() {
  const { products } = useContext(UserContext);
  const params = useParams();

  return (
    <div>
      <Nav />
      <Tittle text={params.cat + " " + "books"} />
      <div className="third">
        <div className="third-con">
          <Filter />
          <AllProduct items={products} />
          <br />
          <GetMoreBooks />
          <br />
          <br />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Product;
